import styled from 'styled-components'

export const LayoutContainer = styled.div`
  max-width: 1440px;
  width: 100%;
`
